import { phoneState } from '../state';
import TasksModule from '@modules/TasksModule';

function handleRemoveCallAccepting(sessionSid: string): void {
  const task = TasksModule.getTask(sessionSid);

  if (!task) {
    return;
  }

  const newCallsAccepting = [...phoneState.callsAccepting];
  phoneState.callsAccepting = newCallsAccepting.filter(
    (callId) => callId !== task.attributes.callId,
  );
}

export default handleRemoveCallAccepting;
